module.exports = __webpack_public_path__ + "static/media/IMG_2652.c221d014.mp4";